// Generalized filtering types that can be used across reports, dashboards, and other features

// Filter operation types that map to BooleanExpr operations
export type FilterOperator =
  | 'equals'
  | 'not_equals'
  | 'contains'
  | 'not_contains'
  | 'contains_list'
  | 'empty'
  | 'not_empty'
  | 'greater_than'
  | 'less_than'
  | 'after'
  | 'before'
  | 'last_modified'
  | 'last_modified_before'
  | 'exists'
  | 'not_exists';

export type FieldEntryDataType = 'number' | 'text' | 'date' | 'boolean';

export type FieldOption = {
  key: string;
  label: string;
  type: FieldEntryDataType;
}

/**
 * The synthetic 'applicant_group' field definition.
 * This special field allows users to reference applicant groups within filter panels.
 */
export const APPLICANT_GROUP_FIELD: FieldOption = {
  key: 'applicant_group',
  label: 'Applicant Group',
  type: 'text'
};

export type FilterLogic = 'and' | 'or';

// Basic filter condition for simple operations
export type FilterCondition = {
  field: string; // Target field name
  operator: FilterOperator;
  value?: string; // For operators that need a value
  // For last_modified operator
  ago?: { amount: number; unit: 'days' | 'weeks' | 'months' };
}

// Filter group that can contain conditions and sub-groups
export type FilterGroup = {
  logic: FilterLogic;
  conditions: Array<FilterCondition | FilterGroup>;
}

// Complete filter configuration - generalized from ReportFilterConfig
export type FilterConfig = {
  enabled: boolean;
  config?: FilterGroup;
}

// UI Filter state for the frontend
export type UIFilterState = {
  activeFilters: FilterCondition[];
  filterGroups: FilterGroup[];
}

// Sorting and grouping types
export type SortDirection = 'asc' | 'desc';

export type GroupByRule = {
  field: string;
  direction: SortDirection;
}

export type GroupByConfig = {
  enabled: boolean;
  rules?: GroupByRule[];
};

// Legacy type aliases for backward compatibility
export type ReportFilterConfig = FilterConfig;
export type ApplicantGroupFilterConfig = FilterConfig;